(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["anywell-charging-help"] && !Shopify.designMode) return;
  try {
    (() => {
  const EXTRA_GAP = 10;
  const RETRY_MS = [0, 16, 50, 100, 250, 500, 1000];
  let pendingTarget = null;
  let retryTimers = [];
  const getStickyOffset = () => {
    let measured = 0;
    document
      .querySelectorAll('.shopify-section--header, sticky-header, .shopify-section--announcement-bar')
      .forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.height <= 0) return;
        if (rect.top <= 1) measured = Math.max(measured, rect.bottom);
        else measured = Math.max(measured, rect.height);
      });
    const cssVar =
      parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height')) || 0;
    const headerVar =
      parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    return Math.max(measured, cssVar, headerVar, 56) + EXTRA_GAP;
  };
  const syncScrollPadding = () => {
    document.documentElement.style.scrollPaddingTop = getStickyOffset() + 'px';
  };
  const alignToSticky = (target) => {
    if (!target) return;
    syncScrollPadding();
    const offset = getStickyOffset();
    const delta = target.getBoundingClientRect().top - offset;
    if (Math.abs(delta) > 1) window.scrollBy(0, delta);
  };
  const clearRetries = () => {
    retryTimers.forEach((id) => clearTimeout(id));
    retryTimers = [];
  };
  const scrollToTarget = (target) => {
    if (!target) return;
    pendingTarget = target;
    clearRetries();
    const run = () => {
      if (pendingTarget !== target) return;
      alignToSticky(target);
    };
    requestAnimationFrame(() => {
      requestAnimationFrame(run);
    });
    RETRY_MS.forEach((ms) => {
      retryTimers.push(setTimeout(run, ms));
    });
  };
  const openChargingPanel = () => {
    if (!window.location.hash.startsWith('#charging-')) return;
    const target = document.getElementById(window.location.hash.slice(1));
    if (!target || !target.closest('.aw-charging')) return;
    if (target.tagName === 'DETAILS') target.open = true;
    scrollToTarget(target);
  };
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  syncScrollPadding();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openChargingPanel, { once: true });
  else openChargingPanel();
  window.addEventListener('hashchange', openChargingPanel);
  window.addEventListener('load', openChargingPanel);
  window.addEventListener('pageshow', openChargingPanel);
})();
  } catch(e) { console.error(e); }
})();

})();
